// Sound effects using Web Audio API

let audioContext: AudioContext | null = null;

function getAudioContext(): AudioContext | null {
  if (typeof window === 'undefined') return null;
  if (!audioContext) {
    try {
      audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
    } catch {
      return null;
    }
  }
  return audioContext;
}

/**
 * Delightful, subtle, tactile bubble-pop sound for clicking the icon.
 * Features a warm resonant sweep and soft percussive transient.
 */
export function playIconClickSound(): void {
  if (typeof window !== 'undefined' && localStorage.getItem('sound-enabled') === 'false') return;
  if (typeof document !== 'undefined' && document.hidden) return;

  const ctx = getAudioContext();
  if (!ctx) return;

  if (ctx.state === 'suspended') {
    ctx.resume().catch(() => {});
  }

  const now = ctx.currentTime;

  // --- Main tactile pop body (warm frequency sweep) ---
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();

  // Rapid upward pop sweep: 320Hz -> 640Hz in 20ms, then soft decay
  osc.type = 'sine';
  osc.frequency.setValueAtTime(320, now);
  osc.frequency.exponentialRampToValueAtTime(680, now + 0.025);
  osc.frequency.exponentialRampToValueAtTime(400, now + 0.08);

  gain.gain.setValueAtTime(0.4, now);
  gain.gain.exponentialRampToValueAtTime(0.001, now + 0.12);

  osc.connect(gain);
  gain.connect(ctx.destination);

  osc.start(now);
  osc.stop(now + 0.12);

  // --- Subtle low-end warm thump (gives tactile weight) ---
  const subOsc = ctx.createOscillator();
  const subGain = ctx.createGain();

  subOsc.type = 'sine';
  subOsc.frequency.setValueAtTime(150, now);
  subOsc.frequency.exponentialRampToValueAtTime(80, now + 0.05);

  subGain.gain.setValueAtTime(0.25, now);
  subGain.gain.exponentialRampToValueAtTime(0.001, now + 0.06);

  subOsc.connect(subGain);
  subGain.connect(ctx.destination);

  subOsc.start(now);
  subOsc.stop(now + 0.06);
}

// Keep legacy export for backwards compatibility
export const playSelectionSound = playIconClickSound;
